import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useEffect } from "react";
export default function MessageChannelSelect({ parentCallback }) {
  const [list, setlist] = useState("");

  const handlechange = (value) => {
    // console.log("targeted value", value);
    setlist(value);
  };
  // console.log("targeted value", list);

  React.useEffect(() => {
    parentCallback(list);
  }, [handlechange]);

  const x = useSelector((state) => state.campaignReducer.campaignState);

  useEffect(()=>{
    setlist(null);
  },[x])
  return (
    <Autocomplete
      disablePortal
      aria-required
      className="w-100"
      id="combo-box-demo"
      size="small"
      value={list}
      options={top100Films}
      getOptionLabel={(option) => option.label || ""}
      // onChange={(e, value) => handlechange(value)}
      onChange={(e,value)=>{
          setlist(value);
        }}
      sx={{ width: 300 }}
      renderInput={(params) => (
        <TextField required {...params} label="Sms Type" />
      )}
    />
  );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
const top100Films = [
  { label: "Promotional", year: 1994 },
  { label: "Transactional", year: 1972 },
  { label: "OTP", year: 1974 },
];
